import React from 'react';

export const iconMap = {
  arrowDown: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  ),
  shirt: (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(17.000000, 17.000000)"
          fill="#231F20"
          fillRule="nonzero"
        >
          <path d="M45.9080877,17.5811001 L40.0022877,4.78520011 C39.878759,4.53585963 39.7066175,4.31373818 39.4959877,4.13190011 L32.4959877,0.131900113 C32.3449329,0.0454719742 32.1739203,0 31.9998877,0 L27.4632877,0 C27.1793381,0 26.9087527,0.120594212 26.7191877,0.332000113 C25.7720605,1.39028167 24.4200982,1.99659821 22.9998877,2 C21.5800383,1.99674538 20.2283891,1.39058797 19.2815877,0.332500113 C19.0918208,0.121020189 18.821127,0 18.5369877,0 L13.9998877,0 C13.825864,0 13.654852,0.0454068981 13.5037877,0.131800113 L6.50378766,4.13180011 C6.29421104,4.31204019 6.12287216,4.53244475 5.99988766,4.78000011 L0.091687662,17.5811001 C-0.0245233764,17.8335953 -0.0305156512,18.1230421 0.0751457281,18.3801306 C0.180807107,18.6372191 0.388607483,18.8387988 0.648787662,18.9366001 L7.99988766,21.6932001 L7.99988766,43 C8.00170637,44.6561004 9.34378733,45.9981814 10.9998877,46 L34.9998877,46 C36.655988,45.9981814 37.998069,44.6561004 37.9998877,43 L37.9998877,21.6932001 L45.3509877,18.9365001 C45.6111678,18.8386988 45.8189682,18.6371191 45.9246296,18.3800306 C46.030291,18.1229421 46.0242987,17.8334953 45.9080877,17.5810001 L45.9080877,17.5811001 Z M22.9998877,4.00000011 C24.8284337,3.99704673 26.5833589,3.27928591 27.8898877,2.00000011 L27.8991877,2.00000011 C27.4239382,4.32788743 25.376142,5.99985567 23.0002377,5.99985567 C20.6243333,5.99985567 18.5765372,4.32788743 18.1012877,2.00000011 L18.1112877,2.00000011 C19.4173449,3.27913775 21.1717824,3.99690457 22.9998877,4.00000011 Z M6.44158766,8.59560011 L7.80248766,19.4829001 L2.35878766,17.4419001 L6.44158766,8.59560011 Z M35.9998877,43.0000001 C35.9991715,43.5519879 35.5518755,43.9992839 34.9998877,44.0000001 L10.9998877,44.0000001 C10.4478998,43.9992839 10.0006039,43.5519879 9.99988766,43.0000001 L9.99988766,21.0000001 C9.99988766,20.9900001 9.99828766,20.9792001 9.99788766,20.9687001 L9.99648766,20.9468001 C9.99518766,20.9232001 9.99508766,20.8994001 9.99198766,20.8759001 L8.07508766,5.53760011 L14.2654877,2.00000011 L16.0711877,2.00000011 C16.5686272,5.44399879 19.5201502,7.99984207 22.9998877,7.99984207 C26.4796252,7.99984207 29.4311481,5.44399879 29.9285877,2.00000011 L31.7342877,2.00000011 L37.9242877,5.53760011 L36.0076877,20.8760001 C36.0045877,20.8996001 36.0044877,20.9234001 36.0031877,20.9472001 L36.0018877,20.9684001 C36.0018877,20.9790001 35.9998877,20.9895001 35.9998877,21.0000001 L35.9998877,43.0000001 Z M38.1972877,19.4829001 L39.5581877,8.59530011 L43.6409877,17.4419001 L38.1972877,19.4829001 Z" />
        </g>
      </g>
    </svg>
  ),
  certificate: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#77856e"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  ),
  checkBoxSelected: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
        fill="currentColor"
      />
      <path
        d="M12.2074 4.79279C12.3949 4.98031 12.5002 5.23462 12.5002 5.49979C12.5002 5.76495 12.3949 6.01926 12.2074 6.20679L7.20741 11.2068C7.01988 11.3943 6.76557 11.4996 6.50041 11.4996C6.23524 11.4996 5.98094 11.3943 5.79341 11.2068L3.79341 9.20679C3.61125 9.01818 3.51045 8.76558 3.51273 8.50339C3.51501 8.24119 3.62018 7.99038 3.80559 7.80497C3.991 7.61956 4.24181 7.51439 4.50401 7.51211C4.7662 7.50983 5.0188 7.61063 5.20741 7.79279L6.50041 9.08579L10.7934 4.79279C10.9809 4.60532 11.2352 4.5 11.5004 4.5C11.7656 4.5 12.0199 4.60532 12.2074 4.79279Z"
        fill="white"
      />
      <path
        d="M4 1H12V-1H4V1ZM15 4V12H17V4H15ZM12 15H4V17H12V15ZM1 12V4H-1V12H1ZM4 15C2.34315 15 1 13.6569 1 12H-1C-1 14.7614 1.23858 17 4 17V15ZM15 12C15 13.6569 13.6569 15 12 15V17C14.7614 17 17 14.7614 17 12H15ZM12 1C13.6569 1 15 2.34315 15 4H17C17 1.23858 14.7614 -1 12 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
        fill="currentColor"
      />
    </svg>
  ),
  checkBoxUnselected: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
        fill="white"
      />
      <path
        d="M4 1H12V-1H4V1ZM15 4V12H17V4H15ZM12 15H4V17H12V15ZM1 12V4H-1V12H1ZM4 15C2.34315 15 1 13.6569 1 12H-1C-1 14.7614 1.23858 17 4 17V15ZM15 12C15 13.6569 13.6569 15 12 15V17C14.7614 17 17 14.7614 17 12H15ZM12 1C13.6569 1 15 2.34315 15 4H17C17 1.23858 14.7614 -1 12 -1V1ZM4 -1C1.23858 -1 -1 1.23858 -1 4H1C1 2.34315 2.34315 1 4 1V-1Z"
        fill="#D1D5DB"
      />
    </svg>
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#77856e"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"
      />
    </svg>
  ),
  id: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#77856e"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
      />
    </svg>
  ),
  info: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6 opacity-50 hover:opacity-100 focus:outline-none"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#77866E"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        clipRule="evenodd"
      />
    </svg>
  ),
  lasso: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49935 6.7142L7.73954 6.90864L8.02085 6.78076L15.5 3.38115V8.63887L5.12738 14.5167L0.980066 1.43668L7.49935 6.7142Z"
        fill="#BFBFBF"
        stroke="#686868"
      />
    </svg>
  ),
  plus: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  ),
  hat: (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_cap</title>
      <g
        id="icon_cap"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Cap"
          transform="translate(17.000000, 19.000000)"
          fill="#231F20"
          fillRule="nonzero"
        >
          <path
            d="M45.8707268,38.248 L42.9996268,28.8035 L42.9996268,24 C42.9567985,14.4992786 36.2634815,6.32789443 26.9572268,4.415 C26.9785788,4.27749959 26.9927314,4.13897741 26.9996268,4 C26.9996268,1.790861 25.2087658,0 22.9996268,0 C20.7904878,0 18.9996268,1.790861 18.9996268,4 C19.0069197,4.1391731 19.02154,4.27786532 19.0434268,4.4155 C9.7364617,6.32722135 3.04221584,14.4988177 2.99962683,24 L2.99962683,28.8048 L0.13142683,38.2648 C-0.154614251,39.1396142 0.0331382049,40.1001756 0.62752683,40.8029 C1.28898985,41.5756795 2.25981521,42.0143355 3.27692683,42.0003407 C3.41986295,41.9997531 3.56266617,41.9912724 3.70462683,41.9746 C8.53082683,41.4146 17.4546268,40.4766 23.0046268,40.4766 C29.4478846,40.6250852 35.8787574,41.1147042 42.2702268,41.9434 C43.4328796,42.1038252 44.5978636,41.6658887 45.3669268,40.7793 C45.9630489,40.0802762 46.1537723,39.1220029 45.8707268,38.248 Z M40.9996268,24 L40.9996268,27.77 C39.9044268,27.59 38.1302268,27.3134 35.9996268,27.0308 L35.9996268,17 C36.0047148,14.3308947 35.1873409,11.7250329 33.6587268,9.537 C38.2542895,12.9265974 40.9763857,18.2896562 40.9996268,24 Z M20.5250268,6.2842 C23.7911646,5.52971502 27.2230887,6.30585548 29.8467337,8.39233339 C32.4703787,10.4788113 33.9993277,13.647851 33.9996268,17 L33.9996268,26.7778 C30.3522427,26.3109026 26.6813163,26.051219 23.0045268,26 C19.3244618,26.0513841 15.6502681,26.3113344 11.9995011,26.7786 L11.9995011,17 C11.9751693,11.8701875 15.520974,7.41337212 20.5250268,6.2842 L20.5250268,6.2842 Z M22.9996268,2 C24.1036025,2.00143238 24.9981945,2.89602435 24.9996268,4 C24.9996268,4.0388 24.9908268,4.0739 24.9887268,4.1119 C23.6661435,3.97927242 22.3336102,3.97927242 21.0110268,4.1119 C21.0089268,4.0745 20.9996268,4.0384 20.9996268,4 C21.0010592,2.89602435 21.8956512,2.00143238 22.9996268,2 Z M12.3407268,9.5369 C10.8119574,11.7249055 9.99450548,14.3308282 9.99962683,17 L9.99962683,27.0312 C7.86902683,27.3137 6.09482683,27.5905 4.99962683,27.7699 L4.99962683,24 C5.02280394,18.2895663 7.74499825,12.9264234 12.3407268,9.5369 L12.3407268,9.5369 Z M43.8228268,39.5078 C43.4879683,39.8663371 42.9968064,40.0349924 42.5123268,39.9578 C36.040472,39.1196373 29.5287353,38.6251434 23.0045268,38.4764 C17.3545268,38.4764 8.34342683,39.4237 3.47452683,39.9881 C2.9933723,40.0604017 2.50749883,39.8908997 2.17572683,39.535 C2.01068959,39.3532717 1.95858802,39.0956819 2.04002683,38.8641 L4.77692683,29.835 C10.8021085,28.7956506 16.8930811,28.1824632 23.0045268,28 C29.1127371,28.1822769 35.2004642,28.7954673 41.2223268,29.835 L43.9596268,38.8379 L43.9655268,38.8565 C44.0399712,39.0833947 43.9853224,39.3328189 43.8228268,39.5078 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  hoodie: (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_jacket</title>
      <g
        id="icon_jacket"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Hoodie"
          transform="translate(17.000000, 17.000000)"
          fill="#231F20"
          fillRule="nonzero"
        >
          <path
            d="M45.4722,18.6900015 L39.9395,7.62460154 C39.8482958,7.46145078 39.733942,7.3123699 39.6,7.18200154 L35.82,4.34690154 C34.5066,1.12130154 30.4222,0.0569015368 30.243,0.0118015368 C30.0329605,-0.00840766557 29.8210686,0.00346151518 29.6146,0.0470015368 C27.4457716,0.575045004 25.2302135,0.888222951 23,0.982001537 C20.7475456,0.884572307 18.5101219,0.565973887 16.32,0.0308015368 C16.1342055,-0.00240315911 15.9446104,-0.00880157411 15.757,0.0118015368 C15.5779,0.0567015368 11.4934,1.12130154 10.18,4.34690154 L6.4,7.18200154 C6.25035869,7.33264409 6.12427603,7.50497953 6.026,7.69320154 L0.5278,18.6900015 C0.181614424,19.3847039 0.000964422761,20.1501219 0,20.9263015 L0,33.9820015 C0.00389005018,35.2491543 0.804811472,36.3767316 2,36.7977015 L2,38.9820015 C2.00110246,40.0861141 2.89588748,40.9808991 4,40.9820015 L7.78,40.9820015 C8.11260725,41.3510081 8.53189739,41.6313483 9,41.7977015 L9,43.9820015 C9.00110246,45.0861141 9.89588748,45.9808991 11,45.9820015 L35,45.9820015 C36.1041125,45.9808991 36.9988975,45.0861141 37,43.9820015 L37,41.7977015 C37.4681045,41.6313521 37.8873955,41.3510113 38.22,40.9820015 L42,40.9820015 C43.1041125,40.9808991 43.9988975,40.0861141 44,38.9820015 L44,36.7977015 C45.1951697,36.3767065 45.9960801,35.2491448 46,33.9820015 L46,20.9263015 C45.9990356,20.1501219 45.8183856,19.3847039 45.4722,18.6900015 Z M33.7334,4.61090154 C31.3951048,5.92696303 28.866351,6.87134913 26.2378,7.41020154 C27.8663128,5.85703722 29.2917052,4.10400819 30.48,2.19290154 C31.7917722,2.63669586 32.9302126,3.48281039 33.7334,4.61090154 Z M27.9254,2.44270154 C26.4769321,4.35879114 24.825535,6.11265037 23,7.67370154 C21.1748061,6.11288159 19.5236514,4.35936588 18.0753,2.44370154 C19.6984458,2.76367969 21.3460572,2.94377376 23,2.98200154 C24.654257,2.94425693 26.3021708,2.76382084 27.9254,2.44270154 L27.9254,2.44270154 Z M15.52,2.19290154 C16.7076795,4.10307852 18.1323318,5.85526639 19.76,7.40770154 C17.134007,6.86425154 14.6072297,5.92011235 12.2683,4.60840154 C13.0716662,3.4817611 14.2093478,2.63664322 15.52,2.19290154 L15.52,2.19290154 Z M11.0373,6.20390154 C14.6745899,8.27892679 18.7086008,9.56354596 22.876,9.97390154 C22.9167236,9.97916791 22.9577375,9.98187323 22.9988,9.98200154 L23.001,9.98200154 C23.0421208,9.9820119 23.0832016,9.97944017 23.124,9.97430154 C27.2913992,9.56394596 31.3254101,8.27932679 34.9627,6.20430154 L37.9683,8.45850154 L37,23.9820015 L37,38.9820015 C36.9992838,39.5339894 36.5519878,39.9812853 36,39.9820015 L10,39.9820015 C9.44801218,39.9812853 9.00071619,39.5339894 9,38.9820015 L9,35.9820015 L9,35.9800015 L8.998,23.9195015 L8.0317,8.45810154 L11.0373,6.20390154 Z M2,20.9263015 C2.00047335,20.4605495 2.10894803,20.0012522 2.3169,19.5845015 L6.234,11.7500015 L7,23.9820015 L7,34.9820015 L3,34.9820015 C2.44801218,34.9812853 2.00071619,34.5339894 2,33.9820015 L2,20.9263015 Z M4,38.9820015 L4,36.9820015 L7,36.9820015 L7,38.9820015 L4,38.9820015 Z M11,43.9820015 L11,41.9820015 L35,41.9820015 L35.001,43.9820015 L11,43.9820015 Z M42,38.9820015 L39,38.9820015 L39,36.9820015 L42,36.9820015 L42,38.9820015 Z M44,33.9820015 C43.9992838,34.5339894 43.5519878,34.9812853 43,34.9820015 L38.9995,34.9820015 L38.998,24.0445015 L39.7663,11.7511015 L43.683,19.5845015 C43.8909866,20.0012438 43.9994956,20.4605416 44,20.9263015 L44,33.9820015 Z"
            id="Shape"
          />
          <path
            d="M14,36.9820015 L32,36.9820015 C32.5522847,36.9820015 33,36.5342863 33,35.9820015 L33,30.9820015 C33,30.4297168 32.5522847,29.9820015 32,29.9820015 C30.3438997,29.9801828 29.0018187,28.6381019 29,26.9820015 C29,26.4297168 28.5522847,25.9820015 28,25.9820015 L18,25.9820015 C17.4477153,25.9820015 17,26.4297168 17,26.9820015 C16.9981813,28.6381019 15.6561003,29.9801828 14,29.9820015 C13.4477153,29.9820015 13,30.4297168 13,30.9820015 L13,35.9820015 C13,36.5342863 13.4477153,36.9820015 14,36.9820015 Z M15,31.8814015 C16.9619393,31.4770551 18.4950536,29.9439408 18.8994,27.9820015 L27.1006,27.9820015 C27.5049464,29.9439408 29.0380607,31.4770551 31,31.8814015 L31,34.9820015 L15,34.9820015 L15,31.8814015 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  pants: (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_pants</title>
      <g
        id="icon_pants"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Long-Pants"
          transform="translate(24.000000, 17.000000)"
          fill="#231F20"
          fillRule="nonzero"
        >
          <path
            d="M31.9700048,12.7573 L30,4.8784 L30,2 C29.9987373,0.895955928 29.1040489,0.00126746556 28,0 L4,0 C2.89596073,0.00126746556 2.00127227,0.895955928 2,2 L2,4.8784 L0.0300048054,12.7573 C0.00982721665,12.8366144 0,12.9181596 0,13 L0,43 C0.00182351657,44.6561003 1.34390448,45.9981813 3,46 L10.2656048,46 C11.7562297,45.9937426 13.0185093,44.8990445 13.2356048,43.4243 L16,24.0708 L18.7646048,43.4238 C18.9814654,44.8986683 20.2436922,45.9936069 21.7344048,46 L29,46 C30.6561051,45.9981813 31.9981861,44.6561003 32,43 L32,13 C32,12.9181596 31.9901824,12.8366144 31.9700048,12.7573 L31.9700048,12.7573 Z M28.2188048,6 L29.6651048,11.7835 C27.9024455,11.2530989 26.6139888,9.73926993 26.3721048,7.9145 L26.1327048,6 L28.2188048,6 Z M4.00000481,2 L28.0000048,2 L28.0000048,4 L4.00000481,4 L4.00000481,2 Z M3.78130481,6 L5.86740481,6 L5.62800481,7.9146 C5.3854749,9.73892943 4.09734841,11.2523059 2.33520481,11.7832 L3.78130481,6 Z M30.0000048,43 C29.9994536,43.5520563 29.5520611,43.9994488 29.0000048,44 L21.7344048,44 C21.2375376,43.9979408 20.8169094,43.6327558 20.7451048,43.1411 L16.9900048,16.8584 C16.9197834,16.3655917 16.497791,15.9994674 16.0000048,15.9994674 C15.5022186,15.9994674 15.0802262,16.3655917 15.0100048,16.8584 L11.2549048,43.1416 C11.1828764,43.6330573 10.7623082,43.9979777 10.2656048,44 L3.00000481,44 C2.44794854,43.9994488 2.00055604,43.5520563 2.00000481,43 L2.00000481,13.9021 C4.95296472,13.4769176 7.25365625,11.1238771 7.61230481,8.1621 L7.88270481,6 L24.1173048,6 L24.3873048,8.1626 C24.7734854,11.114003 27.0591695,13.4575144 30.0000048,13.9173 L30.0000048,43 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  search: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  ),
  shoe: (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_shoes</title>
      <g
        id="icon_shoes"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Sneakers"
          transform="translate(17.000000, 27.000000)"
          fill="#231F20"
          fillRule="nonzero"
        >
          <path
            d="M42.2119946,11.6163567 L37.1963946,10.3634567 C32.5156946,9.42695675 23.7463946,1.79115675 23.6582946,1.71405675 C23.5681331,1.64766964 23.4724114,1.58918607 23.3721946,1.53925675 L20.0752946,0.215956746 C18.6279102,-0.366157138 16.9764693,0.26562874 16.2871946,1.66515675 L15.8955946,2.43955675 C15.2671942,3.70771503 15.6110276,5.24258402 16.7203946,6.12145675 C15.9533284,6.47077081 15.0936903,6.5619977 14.2703946,6.38145675 C12.5896946,5.90975675 10.8172946,3.35315675 10.2342946,2.51145675 C9.77718797,1.85628278 9.02846803,1.46618054 8.22959458,1.46695675 C5.87705655,1.47260767 3.8529113,3.13193289 3.38589458,5.43765675 L1.02259458,17.2560567 L0.0300945848,21.2247567 C-0.0554711041,21.5653398 0.0442975852,21.9258287 0.292794585,22.1739567 C3.21450817,24.8698473 7.02524319,26.3977288 11.0000946,26.4669567 L38.7400946,26.4669567 C40.4938135,26.4572242 42.1169958,25.5386032 43.0281946,24.0401567 L44.8581946,20.9801567 C44.8630946,20.9719567 44.8626946,20.9626567 44.8672946,20.9543567 C44.8753946,20.9400567 44.8872946,20.9284567 44.8942946,20.9137567 C45.5619947,19.5223049 45.9382933,18.0090794 46.0000984,16.4669567 C46.0028996,14.1714209 44.4397946,12.1698905 42.2119946,11.6163567 Z M17.6826946,3.33905675 L18.0762946,2.56075675 C18.3097452,2.09889125 18.8549494,1.88875189 19.3379946,2.07445675 L21.2844946,2.85555675 C20.4839414,3.66528748 19.6116765,4.40082698 18.6783946,5.05315675 L18.0244946,4.61545675 C17.60619,4.33619677 17.4599235,3.78998679 17.6826946,3.33905675 Z M5.34679458,5.83025675 C5.62551351,4.45681135 6.83205526,3.46903287 8.23349458,3.46693142 C8.37635992,3.46540844 8.51066431,3.53492146 8.59189458,3.65245675 C9.87899458,5.50885675 11.6260946,7.71595675 13.7295946,8.30675675 C15.583208,8.6724896 17.5057677,8.26469034 19.0512946,7.17795675 C19.1642114,7.13447112 19.2681221,7.0704974 19.3577946,6.98925675 C20.7218355,6.09759286 21.9750011,5.04688207 23.0908946,3.85925675 C23.5152946,4.21585675 24.1008946,4.69925675 24.7981946,5.25455675 L24.2930946,5.75965675 C24.0364469,6.01143025 23.9347072,6.38159623 24.0266242,6.72917239 C24.1185412,7.07674856 24.3899658,7.34823068 24.7375224,7.44022145 C25.0850791,7.53221222 25.4552666,7.43055101 25.7070946,7.17395675 L26.3895946,6.49145675 C27.1395946,7.05975675 27.9590946,7.65635675 28.8083946,8.24455675 L28.2930946,8.75985675 C28.0340461,9.01112518 27.9304811,9.38247922 28.0221057,9.73154498 C28.1137302,10.0806107 28.3863279,10.3532277 28.7353872,10.4448769 C29.0844465,10.5365262 29.4558078,10.4329875 29.7070946,10.1739567 L30.5070946,9.37395675 C31.1685946,9.79545675 31.8336946,10.1939567 32.4930946,10.5598567 L32.2930946,10.7598567 C32.0340461,11.0111252 31.9304811,11.3824792 32.0221057,11.731545 C32.1137302,12.0806107 32.3863279,12.3532277 32.7353872,12.4448769 C33.0844465,12.5365262 33.4558078,12.4329875 33.7070946,12.1739567 L34.3759946,11.5050567 C35.138686,11.8590927 35.9371995,12.130181 36.7577946,12.3136567 L38.6887946,12.7963567 C37.8788768,13.2815343 36.9429944,13.5149566 36.0000946,13.4669567 C31.2155946,13.4669567 27.5359946,15.9254567 26.3838946,19.8014567 C25.3438946,19.7691567 24.2393946,19.7250567 23.1038946,19.6750567 C20.2292946,13.6104567 10.8500946,10.1758567 4.80299458,8.54915675 L5.34679458,5.83025675 Z M4.41009458,10.5132567 C9.04819458,11.7780567 17.5965946,14.6932567 20.7592946,19.5612567 C20.1973946,19.5312567 19.6415946,19.5032567 19.0585946,19.4689567 C9.95609458,18.9328567 4.91409458,17.4562567 3.14549458,16.8361567 L4.41009458,10.5132567 Z M41.3154946,23.0069567 C40.7684359,23.9074459 39.7937102,24.4600201 38.7400946,24.4669567 L11.0000946,24.4669567 C7.74602699,24.3900437 4.6143588,23.2112083 2.11729458,21.1232567 L2.69729458,18.8014567 C4.79139458,19.5183567 9.92429458,20.9343567 18.9416946,21.4650567 C24.6691946,21.8019567 29.3684946,21.9142567 33.0930946,21.9142567 C37.3739946,21.9142567 40.3550946,21.7658567 42.1343946,21.6381567 L41.3154946,23.0069567 Z M43.3183946,19.5323567 C38.3825943,19.9113001 33.4297455,20.0196624 28.4820946,19.8569567 C29.5544946,17.1549567 32.3764946,15.4669567 36.0000946,15.4669567 C37.8974603,15.6239322 39.7505383,14.8370163 40.9551946,13.3627567 L41.7275946,13.5558567 C43.0639605,13.88886 44.0013961,15.0897264 44.0000959,16.4669567 C43.9591047,17.521434 43.7282065,18.5598659 43.3184946,19.5323567 L43.3183946,19.5323567 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  sort: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="30"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_sort</title>
      <path
        transform="translate(0,-160)"
        d="M443.31 326.67c-5.043-0.003907-9.9453-1.6406-13.977-4.6719l-79.332-59.496-79.332 59.496c-6.668 5-15.496 6.0664-23.16 2.793-7.668-3.2695-13.004-10.387-14.004-18.66-1-8.2773 2.4922-16.453 9.1602-21.457l93.332-70c4.0391-3.0391 8.9531-4.6836 14.004-4.6836s9.9648 1.6445 14.004 4.6836l93.332 70c5.2539 3.9453 8.6016 9.9258 9.2188 16.469 0.61719 6.543-1.5547 13.043-5.9805 17.902s-10.691 7.625-17.266 7.625z"
      />
      <path
        transform="translate(0,50)"
        d="m350 350c-5.0508 0.003906-9.9648-1.6328-14.004-4.6719l-93.332-70c-4.9492-3.7148-8.2227-9.2422-9.0938-15.367-0.875-6.125 0.72266-12.348 4.4336-17.297 3.7148-4.9492 9.2422-8.2227 15.367-9.0938 6.125-0.875 12.348 0.72266 17.297 4.4336l79.332 59.496 79.332-59.496c6.668-5 15.496-6.0664 23.16-2.793 7.668 3.2695 13.004 10.387 14.004 18.66 1 8.2773-2.4922 16.453-9.1602 21.457l-93.332 70c-4.0391 3.0391-8.9531 4.6758-14.004 4.6719z"
      />
    </svg>
  ),
  sortDown: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="30"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_sort_down</title>
      <path
        transform="translate(0,50)"
        d="m350 350c-5.0508 0.003906-9.9648-1.6328-14.004-4.6719l-93.332-70c-4.9492-3.7148-8.2227-9.2422-9.0938-15.367-0.875-6.125 0.72266-12.348 4.4336-17.297 3.7148-4.9492 9.2422-8.2227 15.367-9.0938 6.125-0.875 12.348 0.72266 17.297 4.4336l79.332 59.496 79.332-59.496c6.668-5 15.496-6.0664 23.16-2.793 7.668 3.2695 13.004 10.387 14.004 18.66 1 8.2773-2.4922 16.453-9.1602 21.457l-93.332 70c-4.0391 3.0391-8.9531 4.6758-14.004 4.6719z"
      />
    </svg>
  ),
  sortUp: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="30"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>icon_sort_up</title>
      <path
        transform="translate(0,-160)"
        d="M443.31 326.67c-5.043-0.003907-9.9453-1.6406-13.977-4.6719l-79.332-59.496-79.332 59.496c-6.668 5-15.496 6.0664-23.16 2.793-7.668-3.2695-13.004-10.387-14.004-18.66-1-8.2773 2.4922-16.453 9.1602-21.457l93.332-70c4.0391-3.0391 8.9531-4.6836 14.004-4.6836s9.9648 1.6445 14.004 4.6836l93.332 70c5.2539 3.9453 8.6016 9.9258 9.2188 16.469 0.61719 6.543-1.5547 13.043-5.9805 17.902s-10.691 7.625-17.266 7.625z"
      />
    </svg>
  ),
  document1: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="34px"
      height="34px"
      viewBox="0 0 34 34"
    >
      <image
        id="image0"
        width="34"
        height="34"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
          AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA
          CXBIWXMAAAsTAAALEwEAmpwYAAAFFklEQVRYw82YWXOTVRjHf+dt0qYhTds0bbO0zdZVqBYqcOHC
          Bdt4gTOON45eOXrlOI4XXvEBuPUD6IXMgKgjCjLIIMIAMg6brC2U2qRtSJsuWbpkX/p6kTZLaeFN
          wRn+Vznned7n/M+znOecCFmWZV4CqJQoLYUHOHtllMwGFqhvf4s3e+qen0g2MsK5n3/h5A0fshDI
          sowQIi9fPV4N+/7e5yeSCA1x5sefuHBnAlkINIY22oyaksVXIls8FmQIz04RmIsDAiVYn0gqwI3z
          v3HpzgQpQFbr6d39MZ/usTzbasLLicPf8cetCUBZCkprxyPAP2d/5dTFEeJFuy4L8op3lOEJj6Rj
          fi4fP8bF2x7mM4WckFG8uTyeljtPJZKJB7l5+gfO3XhIOCk9aUy53YJjFJIvEJFjDJz9ntN/PciT
          KBiTkctxh9pI3653Mb0WR93UUA6RBNP3znHq8n1mk0+mTc4rZbijQou9pw97GZ5TsZRk7Mpxjp68
          hC/6jMXkwo/4/CTj7mliaiOv9LahKdbLxJh67GEynEJbb8PlaEBdLE+GGBnxsiBXY2lzYdKrUJFZ
          YMw/yWwEKi397NtmXmeXVVhdNcuDJYKeW/x+5ARD8R6++PorthQxSfgHOHHkMLd9GRrb9/HJ5+/j
          qC7IY+4LfPPtedLmnbz3gROTHlQrLhdCoLH0c+BAvxLfU29oxGTWMPTvKG4fbGlfkWWZnh5jwp8C
          JOZCbjzeKI6uTcvyFJO+GVJJQWOtlRZTzleFhJApKw+0DUaaTCZUIoPPG2BpRZCKMOkZJJiVUKkE
          6blZvGPjJPI8w/gmF8iIahqsDkyVlBLJHVrKK0PommkxtVIjyQSGHxFeno9Hgwze9pKVTLy+04Z6
          KcKIx01wMUdVjoSYWAgjazSYO1tZiZiUOwIpHFqKocNsaaRGLxENjOBfzM0m/X/zMKRGMnWze/8u
          7JUZgqPjeMMRAKKhMOFgGHWFFbu1Km9NApGPiCiLiUBvaaFZV00kMsWMPwFk8dwdJoIWZ28nBsN2
          +nvUMO/m2tAskCYY9BMMy1S1bsa5iSIiosR2WRD1LbQ31JKOxwjOzJJKubkzOAdVjXQ7LGjVahzb
          +tCJKMN3PcSWMsyHJgknKzB2u9BRTEQuIlF2b6unq6sWKbHIzIwf78MB3NEsOosVu9mIBNRZXsVW
          B5nRm9yaTjI7MU5cNtDp1JVYyiXrcp6W32Mlml1ONMTxBx5x7foYi3GBydyJtSlXlvp6C3anASn7
          mMtXPUyPh5F1drobNKssFYVEbKCrVdi2slmTITR4k+t3PaSr9Lj6ejEs16OkM9Lh6qJencF36SjX
          /Srqejpo1lSu4xGgjK5dgLDicEI2kSCRTlOtNdPhqCmSa2lptVJTI5GNR4jJVbS01KGuLO1pufJd
          JlBWhy34hNYOW76XaFw7cOlLNXStNuz62tygqgl7cyPqVb01f8TLyIrvDqvR1L2T9itRZqhm6zYX
          2tUK1S7e2G5jYLGCisY2HM3G0iZI0X1EFJ0n5cLg3MuXh/Y+RUOFbc9nHNqzvoa0kVr5P1ASmo1U
          zZpIB7j65xmuPpihaftHfPi2SQmRHARig8m6BrIxpryjDA9PEHckFH1S6L4ov/qXBYV7KymiF/0c
          f9ZztBgloZm/d4yDB4+XbWT1sxM5TSIWY0koD3fJu0ZKLxIMvuDdKn7XqGvp3vEO2rZFssq+WZfI
          WnOVzcreNeJl+aPmP2wrANt0D4PNAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTAzLTI4VDE3OjEw
          OjQ4KzAzOjAwolfxzgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wMy0yOFQxNzoxMDo0OCswMzow
          MNMKSXIAAAAASUVORK5CYII="
      />
    </svg>
  ),
  dotCircleBlue: (
    <svg
      width="32"
      height="32"
      viewBox="-2 -2 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="white"
      />
      <circle cx="16" cy="16" r="5" fill="#2F73DA" />
      <path
        d="M16 30C8.26801 30 2 23.732 2 16H-2C-2 25.9411 6.05887 34 16 34V30ZM30 16C30 23.732 23.732 30 16 30V34C25.9411 34 34 25.9411 34 16H30ZM16 2C23.732 2 30 8.26801 30 16H34C34 6.05887 25.9411 -2 16 -2V2ZM16 -2C6.05887 -2 -2 6.05887 -2 16H2C2 8.26801 8.26801 2 16 2V-2Z"
        fill="#2F73DA"
      />
    </svg>
  ),
  export: (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66663 11.1666L2.66663 11.8333C2.66663 12.9379 3.56206 13.8333 4.66663 13.8333L11.3333 13.8333C12.4379 13.8333 13.3333 12.9379 13.3333 11.8333L13.3333 11.1666M10.6666 5.83331L7.99996 3.16665M7.99996 3.16665L5.33329 5.83331M7.99996 3.16665L7.99996 11.1666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevron: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 9L12 16L5 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  infoCircle: (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16667 10.6667H8.5V8H7.83333M8.5 5.33333H8.50667M14.5 8C14.5 11.3137 11.8137 14 8.5 14C5.18629 14 2.5 11.3137 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6949 3.70503C11.9683 3.97839 11.9683 4.42161 11.6949 4.69497L6.09495 10.295C5.82158 10.5683 5.37837 10.5683 5.105 10.295L2.305 7.49497C2.03163 7.22161 2.03163 6.77839 2.305 6.50503C2.57837 6.23166 3.02158 6.23166 3.29495 6.50503L5.59998 8.81005L10.705 3.70503C10.9784 3.43166 11.4216 3.43166 11.6949 3.70503Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  times: (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 10.5L10.5 3.5M3.5 3.5L10.5 10.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sortIcon: (
    <svg
      viewBox="0 0 320 512"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z" />
    </svg>
  ),
  sortAscIcon: (
    <svg
      viewBox="0 0 320 512"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224z" />
    </svg>
  ),
  sortDescIcon: (
    <svg
      viewBox="0 0 320 512"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z" />
    </svg>
  ),
  pinIcon: (
    <svg viewBox="0 0 30 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5249 1.08475C16.0233 1.02872 15.515 1.00047 15 1C14.4854 1 13.9771 1.02828 13.4751 1.08484C3.42887 2.20708 -2.02866 13.6956 2.75706 23.8248L13.4416 47.9392C13.7503 48.5926 14.3489 49 15 49C15.6511 49 16.2497 48.5926 16.5584 47.9392L27.2429 23.8248C32.0287 13.6955 26.5711 2.20699 16.5249 1.08475Z"
        fill="#e2e2e2"
      />
      <path
        d="M16.5249 1.08475C16.0233 1.02872 15.515 1.00047 15 1C14.4854 1 13.9771 1.02828 13.4751 1.08484C3.42887 2.20708 -2.02866 13.6956 2.75706 23.8248L13.4416 47.9392C13.7503 48.5926 14.3489 49 15 49C15.6511 49 16.2497 48.5926 16.5584 47.9392L27.2429 23.8248C32.0287 13.6955 26.5711 2.20699 16.5249 1.08475Z"
        stroke="#000000"
        strokeWidth="2"
      />
    </svg>
  ),
  plusInCircle: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9V12M12 12V15M12 12H15M12 12H9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  unArchiveIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6C20.1046 6 21 6.89543 21 8C21 9.10457 20.1046 10 19 10V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20L5 10C3.89543 10 3 9.10457 3 8C3 6.89543 3.89543 6 5 6M10 14H14"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10H9"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10H19"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3L12 11"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1716 3.17163L15.0001 6.00006"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6L11.8284 3.17157"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  archiveIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00012 8H19.0001M5.00012 8C3.89555 8 3.00012 7.10457 3.00012 6C3.00012 4.89543 3.89555 4 5.00012 4H19.0001C20.1047 4 21.0001 4.89543 21.0001 6C21.0001 7.10457 20.1047 8 19.0001 8M5.00012 8L5.00012 18C5.00012 19.1046 5.89555 20 7.00012 20H17.0001C18.1047 20 19.0001 19.1046 19.0001 18V8M10.0001 12H14.0001"
        stroke="#9CA3AF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copyIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 7V15C8 16.1046 8.89543 17 10 17H16M8 7V5C8 3.89543 8.89543 3 10 3H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V15C20 16.1046 19.1046 17 18 17H16M8 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21H14C15.1046 21 16 20.1046 16 19V17"
        stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  officeBuildingNewIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 21L21 21M19 21H14M19 21V12.5M5 21V5C5 3.89543 5.89543 3 7 3H15.5M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19 3V9M22 6L16 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};
